import { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import useGetCurrentLocation from './useGetCurrentLocation';

/**
 * @param {object} props
 * @param {React.RefObject} props.mapContainerRef - ref to the div where map is rendered
 * @param {{ lat: number, lng: number }} [props.defaultLatLng]
 * @param {boolean} [props.draggable]
 */
function useMapboxMap({ mapContainerRef, defaultLatLng, draggable = false }) {
    const { lat: currentLat, lng: currentLng } = useGetCurrentLocation();

    const [coordLocation, setCoordLocation] = useState([]);
    const mapRef = useRef(null);

    useEffect(() => {
        if (coordLocation?.length < 1 && !defaultLatLng?.lng && !defaultLatLng?.lat) return () => {};

        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;

        const initMap = () => {
            if (!mapContainerRef.current) return;

            const centerdLocation = coordLocation?.length > 0 ? coordLocation : [defaultLatLng?.lng, defaultLatLng?.lat];

            const map = new mapboxgl.Map({
                container: mapContainerRef.current,
                style: 'mapbox://styles/mapbox/streets-v11',
                center: centerdLocation,
                zoom: 15,
            });

            const marker = new mapboxgl.Marker({ color: '#007F78', draggable }).setLngLat(centerdLocation).addTo(map);

            marker.on('dragend', () => {
                const { lng, lat } = marker.getLngLat();
                setCoordLocation([lng, lat]);
            });

            mapRef.current = map;
        };

        initMap();

        return () => {
            if (mapRef.current && mapRef.current.remove) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [coordLocation, draggable, mapContainerRef, currentLat, currentLng, defaultLatLng]);

    useEffect(() => {
        if (!defaultLatLng && currentLng && currentLat) {
            setCoordLocation([currentLng, currentLat]);
        }
    }, [defaultLatLng, currentLat, currentLng]);

    return { mapRef, lat: coordLocation?.[1], lng: coordLocation?.[0] };
}

export default useMapboxMap;
